import { Star } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { CtaButton } from "./CtaButton";

const TESTIMONIALS = [
  {
    text: "Dokumenty od Pauliny to konkret bez prawniczego żargonu. Regulamin salonu i klauzule RODO miałam gotowe w kilka dni.",
    author: "Karolina",
    role: "właścicielka salonu kosmetycznego · Warszawa",
  },
  {
    text: "W końcu czuję się spokojna na wypadek kontroli. Wszystko wyjaśnione po ludzku, punkt po punkcie.",
    author: "Marta",
    role: "właścicielka salonu fryzjerskiego · Wrocław",
  },
  {
    text: "Paulina pamięta o szczegółach, o których sama bym nie pomyślała. Współpraca to czysta przyjemność.",
    author: "Aleksandra",
    role: "studio beauty · Poznań",
  },
];

export const TestimonialsSection = ({ onBuy }) => (
  <section
    id="opinie"
    data-testid="testimonials-section"
    className="bg-white px-6 py-24 sm:px-10 sm:py-32 lg:px-16"
  >
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <Kicker index="03" label="Opinie" />
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Właścicielki salonów o współpracy z Pauliną
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3 sm:gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.author} delay={0.08 * i}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="flex h-full flex-col rounded-3xl border border-sand bg-cream p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-brick/10 sm:p-8"
            >
              <div className="flex gap-1" aria-label="5 na 5 gwiazdek">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-brick text-brick" />
                ))}
              </div>
              <blockquote className="mt-5 flex-1 font-display text-lg italic leading-relaxed text-choc">
                „{t.text}”
              </blockquote>
              <figcaption className="mt-6 border-t border-sand pt-4">
                <span className="block text-sm font-semibold">{t.author}</span>
                <span className="text-xs uppercase tracking-wider text-clay">{t.role}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 flex justify-center">
        <CtaButton onBuy={onBuy} testid="testimonials-cta-button" />
      </Reveal>
    </div>
  </section>
);
